<template>
  <div>
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
export default {
  name: "Canvas",
  props: {
    imageUrl: {
      type: String,
      required: false
    },
    area: {
      type: Array,
      required: false
    },
    task: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      canvas: undefined,
      ctx: undefined,
      mousedown: false,
      last_mousex: 0,
      last_mousey: 0,
      coordinates: [],
      percentCoordinates: [],
      dotCount: 0
    };
  },
  created() {},
  mounted() {
    if (this.imageUrl && this.area) {
      this.drawBacgkroundImage(this.imageUrl, this.area, this);
    } else {
      this.drawBacgkroundImage(this.imageUrl);
    }
  },
  methods: {
    drawBacgkroundImage(url, area, main) {
      const canvas = document.getElementById("canvas");
      this.canvas = canvas;
      const canvasx = canvas.offsetWidth;
      const canvasy = canvas.offsetHeight;

      this.canvas.width = canvasx;
      this.canvas.height = canvasy;
      canvas.width = canvasx;
      canvas.height = canvasy;

      const image = new Image();
      image.src = url;
      const ctx = this.canvas.getContext("2d");
      this.ctx = ctx;
      let pin = {};
      if(this.task.marker_area !== null && this.task.marker_area !== undefined) {
        pin = {
          x: this.task.marker_area[0] * canvasx,
          y: this.task.marker_area[1] * canvasy,
          color: "red"
        };
      }
      image.onload = function() {
        ctx.drawImage(
          image,
          0,
          0,
          image.width,
          image.height,
          0,
          0,
          canvas.width,
          canvas.height
        );
        ctx.save();
        ctx.translate(pin.x, pin.y);
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.bezierCurveTo(2, -10, -20, -25, 0, -30);
        ctx.bezierCurveTo(20, -25, -2, -10, 0, 0);
        ctx.fillStyle = pin.color;
        ctx.fill();
        ctx.strokeStyle = "black";
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(0, -21, 3, 0, Math.PI * 2);
        ctx.closePath();
        ctx.fillStyle = "black";
        ctx.fill();

        ctx.restore();
      };
    },
    compare(a, b) {
      const distanceA = a.distance;
      const distanceB = b.distance;

      let comparison = 0;

      if (distanceA > distanceB) {
        comparison = 1;
      } else if (distanceA < distanceB) {
        comparison = -1;
      }
      return comparison;
    }
	},
	computed: {
		
	},
  watch: {
    imageUrl(newValue, oldvalue) {
      this.drawBacgkroundImage(newValue);
    },
    area(newValue, oldvalue) {
      this.drawBacgkroundImage(this.imageUrl);
    }
  }
};
</script>

<style lang="scss">
#canvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/tasks/AssetLocation.vue